import React from 'react';

import HStack from 'common/ui/HStack';
import VStack from 'common/ui/VStack';
import Field from 'common/uiV3/Field';
import Input from 'common/uiV3/Input';

import type {
  CustomFieldFormState,
  FieldFormState,
} from 'common/subdomain/admin/v2/hooks/useIdeaFieldForm';

type RangeFieldInputsProps = {
  formState: FieldFormState;
  setValue: (field: keyof CustomFieldFormState, value: string | string[]) => void;
  readOnly: boolean;
  loading: boolean;
};

const RangeFieldInputs = ({ formState, setValue, readOnly, loading }: RangeFieldInputsProps) => {
  const handleOptionChange = (index: number, value: string) => {
    if (!('options' in formState)) {
      return;
    }

    const existingOptions = formState.options ?? [];
    existingOptions[index] = value.replace(/[^0-9-]/g, '');
    setValue('options', existingOptions);
  };

  const setMin = (value: string) => handleOptionChange(0, value);
  const setMax = (value: string) => handleOptionChange(1, value);

  const [min, max] = `options` in formState ? (formState.options ?? ['', '']) : ['', ''];

  return (
    <Field>
      <Field.Label required>Range</Field.Label>
      <Field.Description>Define the range for this field.</Field.Description>
      <Field.Content>
        <HStack className="gap-2 space-between w-full">
          <VStack className="flex-1">
            <span className="text-base">Min</span>
            <Input disabled={readOnly || loading} onChange={setMin} placeholder="0" value={min} />
          </VStack>
          <VStack className="flex-1">
            <span className="text-base">Max</span>
            <Input disabled={readOnly || loading} onChange={setMax} placeholder="100" value={max} />
          </VStack>
        </HStack>
      </Field.Content>
    </Field>
  );
};

export default RangeFieldInputs;
